import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import paginate from 'jw-paginate';

@Component({
    selector: 'jw-pagination',
    template: `<ul *ngIf="pager.pages && pager.pages.length" class="pagination">
  <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item previous-item">
      <a (click)="setPage(pager.currentPage - 1)" class="page-link d-flex justify-content-center align-items-center" aria-label="Previous">
        <svg xmlns="http://www.w3.org/2000/svg" width="7.104" height="11.103"
          viewBox="0 0 7.104 11.103">
          <g id="Grupo_836" data-name="Grupo 836"
            transform="translate(5.69 9.69) rotate(180)">
            <line id="Línea_2" data-name="Línea 2" x1="4.276" y2="4"
              transform="translate(0 0)" fill="none" stroke="#fff"
              stroke-linecap="round" stroke-width="2" />
            <line id="Línea_3" data-name="Línea 3" x2="4.276" y2="4.275"
              transform="translate(0 4)" fill="none" stroke="#fff"
              stroke-linecap="round" stroke-width="2" />
          </g>
        </svg>
      </a>
  </li>
  <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}" class="page-item number-item">
      <a (click)="setPage(page)" class="page-link">{{page}}</a>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item next-item">
    <a (click)="setPage(pager.currentPage + 1)" class="page-link d-flex justify-content-center align-items-center" aria-label="Next">
      <svg xmlns="http://www.w3.org/2000/svg" width="7.104" height="11.103"
        viewBox="0 0 7.104 11.103">
        <g id="Grupo_836" data-name="Grupo 836"
          transform="translate(5.69 9.69) rotate(180)">
          <line id="Línea_2" data-name="Línea 2" x1="4.276" y2="4"
            transform="translate(0 0)" fill="none" stroke="#fff"
            stroke-linecap="round" stroke-width="2" />
          <line id="Línea_3" data-name="Línea 3" x2="4.276" y2="4.275"
            transform="translate(0 4)" fill="none" stroke="#fff"
            stroke-linecap="round" stroke-width="2" />
        </g>
      </svg>
    </a>
  </li>
</ul>`
/*
  <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item first-item" style="display:none">
      <a (click)="setPage(1)" class="page-link">First</a>
  </li>
  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item last-item">
    <a (click)="setPage(pager.totalPages)" class="page-link">Last</a>
  </li>
*/
})

export class JwPaginationComponent implements OnInit, OnChanges {
    @Input() items: Array<any>;
    @Output() changePage = new EventEmitter<any>(true);
    @Input() initialPage = 1; @Input() pageSize = 10;
    @Input() maxPages = 10;

    pager: any = {};

    ngOnInit() {
        // set page if items array isn't empty
        if (this.items && this.items.length) {
            this.setPage(this.initialPage);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.setPage(this.initialPage);
        }
    }

    setPage(page: number) {
        // get new pager object for specified page
        this.pager = paginate(this.items.length, page, this.pageSize, this.maxPages);

        // get new page of items from items array
        var pageOfItems = this.items.slice(this.pager.startIndex, this.pager.endIndex + 1);

        // call change page function in parent component
        this.changePage.emit(pageOfItems);
    }
}
